import React from "react";
import { observer } from "mobx-react";
import Card from "../../../../components/layouts/card/card";
import "./overview-card.scss";
import { FONT_VARIANT } from "../../../../components/fonts/font-props";
import FontBody2 from "../../../../components/fonts/font-body2/font-body2";
import FontHeading3 from "../../../../components/fonts/font-heading3/font-heading3";
import { ButtonLink } from "../../../../components/inputs/button-link/button-link";
import { BUTTON_VARIANTS } from "../../../../components/inputs/button-variants";
import { CARD_SPACING_VARIANT } from "../../../../components/layouts/card/card.types";
import FontHeading2 from "../../../../components/fonts/font-heading2/font-heading2";
import { WalletStore } from "../../stores/wallet/wallet-store";
import Currency from "../../../../components/currency/currency";
import { isSet } from "../../../../models/model-types-methods";
import TextTruncate from "../../../../components/text-truncate/text-truncate";
import ResolveCapability from "../../../../components/resolve-capability/resolve-capability";
import { PROFILE_CAPABILITIES } from "../../../../models/ProfileCapabilities";


interface IOverviewCard {
	walletStore: WalletStore;
}

const OverviewCard: React.FC<IOverviewCard> = observer(({walletStore}) => (
	<Card spacingVariant={CARD_SPACING_VARIANT.SMAll} isLoading={walletStore.isLoading}>
		{!walletStore.isLoading && (
			<div className={"overview-card"}>
				<div className="overview-card-header">
					<FontHeading2 variant={FONT_VARIANT.BOLD}>{"Billing Overview"}</FontHeading2>
					<FontBody2>{"View your billing history, manage your wallet, and track recent charges."}</FontBody2>
				</div>
				<div className="overview-card-plan-info">
					<div className="overview-card-plan-details">
						<FontHeading3 variant={FONT_VARIANT.BOLD}>{"Current Plan"}</FontHeading3>
						<div className="plan-info-grid">
							<div className="plan-info-grid-item">
								<FontBody2>{"Your Plan"}</FontBody2>
								<FontBody2 variant={FONT_VARIANT.BOLD}>
									<TextTruncate
										maxWidth={{value: 130, type: 'px'}}>{walletStore.planName}</TextTruncate>
								</FontBody2>
							</div>
							{isSet(walletStore.planCycle) && (
								<div className="plan-info-grid-item">
									<FontBody2>{"Billing Cycle"}</FontBody2>
									<FontBody2 variant={FONT_VARIANT.BOLD}>{walletStore.planCycle}</FontBody2>
								</div>
							)}
							<div className="plan-info-grid-item">
								<FontBody2>{"Plan Price"}</FontBody2>
								<FontBody2 variant={FONT_VARIANT.BOLD}>
									{isSet(walletStore.planPrice)
										? walletStore.planPrice! > 0
											? <Currency amount={walletStore.planPrice} currencyCode={'USD'}/>
											: 'Free'
										: null}
								</FontBody2>
							</div>
						</div>
					</div>
					<ResolveCapability capability={PROFILE_CAPABILITIES.SUBSCRIPTION_PLANS}>
						{({isSupported}) => isSupported && (
							<div className="overview-card-upgrade-button">
								<ButtonLink
									href={'subscription-plans'}
									target="_self"
									variant={BUTTON_VARIANTS.PrimaryAccent}
									text={"Upgrade Plan"}
								/>
							</div>
						)}
					</ResolveCapability>
				</div>
			</div>
		)}
	</Card>
));

export default OverviewCard;
